var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletTrendingDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 16,
    fill: "#F59E0B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4 23.5999C22.0818 23.5999 21.7766 23.7263 21.5515 23.9514C21.3265 24.1764 21.2 24.4816 21.2 24.7999C21.2 25.1182 21.3265 25.4234 21.5515 25.6484C21.7766 25.8735 22.0818 25.9999 22.4 25.9999H28.4C28.7183 25.9999 29.0235 25.8735 29.2486 25.6484C29.4736 25.4234 29.6 25.1182 29.6 24.7999V18.7999C29.6 18.4816 29.4736 18.1764 29.2486 17.9514C29.0235 17.7263 28.7183 17.5999 28.4 17.5999C28.0818 17.5999 27.7766 17.7263 27.5515 17.9514C27.3265 18.1764 27.2001 18.4816 27.2001 18.7999V21.9031L22.0484 16.7515C21.8234 16.5265 21.5182 16.4002 21.2 16.4002C20.8819 16.4002 20.5767 16.5265 20.3517 16.7515L17.6 19.5031L12.4484 14.3515C12.2221 14.1329 11.919 14.012 11.6044 14.0147C11.2897 14.0174 10.9888 14.1436 10.7663 14.3661C10.5438 14.5886 10.4176 14.8896 10.4148 15.2042C10.4121 15.5189 10.5331 15.822 10.7516 16.0483L16.7516 22.0483C16.9767 22.2733 17.2819 22.3996 17.6 22.3996C17.9182 22.3996 18.2234 22.2733 18.4484 22.0483L21.2 19.2967L25.5033 23.5999H22.4Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletTrendingDown);
export default __webpack_public_path__ + "static/media/wallet-trending-down.fd2ba1767f0f028c6fe20089a88885c5.svg";
export { ForwardRef as ReactComponent };